<mat-form-field *ngIf="!disabled">
  <mat-label>{{ placeholder }}</mat-label>
    <input (ngModelChange)="updateNgModel($event);" [formControl]="childControl" [matAutocomplete]="autoPromotions" [ngModel]="childValue"
           [required]="required" matInput>
    <button (click)="childValue = null; value = null;" mat-icon-button matIconSuffix type="button">
        <mat-icon>close</mat-icon>
    </button>
    <mat-autocomplete #autoPromotions="matAutocomplete" [displayWith]="displayFn">
        <mat-option *ngFor="let res of listResults" [ngStyle]="{'line-height': 'normal', 'height': !hideCode ? '72px' : 'inherit'}" [value]="res">
            <ng-container *ngIf="!hideCode">{{res.Code }}</ng-container>
            {{res.getTitle()}}
        </mat-option>
    </mat-autocomplete>
</mat-form-field>
<mat-form-field *ngIf="disabled">
  <mat-label>{{placeholder}}</mat-label>
    <input [disabled]="true" [required]="required" [value]="childValue?.Code"
           matInput>
</mat-form-field>
